// @ts-nocheck
// @ts-ignore
class CustomToast {
    constructor() {
      this.toastElement = null;
    }

    /**
     * Returns the container to append the toast to.
     * When the cart drawer dialog is open, appends inside it (so toast is in the top layer and visible).
     * Otherwise appends to document.body.
     */
    getToastContainer() {
      const openDialog = document.querySelector('cart-drawer-component dialog[open]');
      if (openDialog) {
        let wrapper = openDialog.querySelector('.custom-toast-wrapper');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'custom-toast-wrapper';
          wrapper.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999;overflow:visible;';
          openDialog.appendChild(wrapper);
        }
        return wrapper;
      }
      return document.body;
    }

    /**
     * Returns the transform value for the toast when fully visible (centered correctly for the given position).
     */
    getVisibleTransform(position) {
      if (!position) return 'translate(0, 0)';
      if (position === 'center center') return 'translate(-50%, -50%)';
      if (position === 'top center' || position === 'bottom center') return 'translate(-50%, 0)';
      if (position === 'center left' || position === 'center right') return 'translate(0, -50%)';
      return 'translate(0, 0)';
    }

    /**
     * Returns the transform value for the toast exit animation (combines position centering with slide direction).
     */
    getExitTransform(position, slideDirections) {
      const centerX = position && (position === 'center center' || position === 'top center' || position === 'bottom center');
      const centerY = position && (position === 'center center' || position === 'center left' || position === 'center right');
      let x = centerX ? '-50%' : '0';
      let y = centerY ? '-50%' : '0';
      if (slideDirections === 'left to right') x = '-100%';
      if (slideDirections === 'right to left') x = '100%';
      if (slideDirections === 'top to bottom') y = '100%';
      if (slideDirections === 'bottom to top') y = '-100%';
      if (centerX && (slideDirections === 'left to right' || slideDirections === 'right to left')) {
        x = slideDirections === 'left to right' ? 'calc(-50% - 100%)' : 'calc(50% + 100%)';
      }
      if (centerY && (slideDirections === 'top to bottom' || slideDirections === 'bottom to top')) {
        y = slideDirections === 'top to bottom' ? 'calc(-50% + 100%)' : 'calc(-50% - 100%)';
      }
      return 'translate(' + x + ', ' + y + ')';
    }

    init(toastMessage, type, position, slideDirections, visibleTimer) {
      if (!toastMessage || typeof toastMessage !== 'string') {
        console.error('Toast message must be a non-empty string');
        return;
      }

      // Remove existing toast if any
      if (this.toastElement) {
        this.toastElement.remove();
      }

      const toast = document.createElement('div');
      toast.className = 'custom-toast';
      toast.textContent = toastMessage;
      toast.setAttribute('data-toast-position', position || '');

      // Type
      if (type === 'error') toast.classList.add('toast-error');
      if (type === 'warning') toast.classList.add('toast-warning');
      if (type === 'info') toast.classList.add('toast-info');

      // Position
      this.applyPosition(toast, position);

      // Slide direction (initial state)
      this.applyInitialTransform(toast, position, slideDirections);

      this.getToastContainer().appendChild(toast);

      const visibleTransform = this.getVisibleTransform(position);

      // Trigger animation to visible state (correct center for position)
      setTimeout(() => {
        toast.style.transform = visibleTransform;
        toast.style.opacity = '1';
      }, 10);

      // Auto hide
      setTimeout(() => {
        this.hideToast(toast, slideDirections);
      }, visibleTimer || 4000);

      this.toastElement = toast;
    }

    applyPosition(toast, position) {
      toast.style.position = 'fixed';
      toast.style.zIndex = '99';
      toast.style.pointerEvents = 'auto';

      const isMobile = typeof window !== 'undefined' && window.innerWidthCached <= 749;
      const inset = isMobile ? '16px' : '20px';
      const map = {
        'top left': ['top', inset, 'left', inset],
        'top center': ['top', inset, 'left', '50%'],
        'top right': ['top', inset, 'right', inset],
        'bottom left': ['bottom', inset, 'left', inset],
        'bottom center': ['bottom', inset, 'left', '50%'],
        'bottom right': ['bottom', inset, 'right', inset],
        'center left': ['top', '50%', 'left', inset],
        'center center': ['top', '50%', 'left', '50%'],
        'center right': ['top', '50%', 'right', inset],
      };

      if (map[position]) {
        const pos = map[position];
        toast.style[pos[0]] = pos[1];
        toast.style[pos[2]] = pos[3];
      }

      if (position && position.includes('center')) {
        toast.style.transform = 'translate(-50%, -50%)';
      }
    }

    applyInitialTransform(toast, position, slideDirections) {
      toast.style.transition = 'all 300ms ease';
      toast.style.opacity = '0';

      const centerX = position && (position === 'center center' || position === 'top center' || position === 'bottom center');
      const centerY = position && (position === 'center center' || position === 'center left' || position === 'center right');
      const yVal = centerY ? '-50%' : '0';
      const xVal = centerX ? '-50%' : '0';

      if (slideDirections === 'right to left') {
        toast.style.transform = centerX ? 'translate(calc(50% + 100%), ' + yVal + ')' : (centerY ? 'translate(100%, -50%)' : 'translateX(100%)');
      } else if (slideDirections === 'left to right') {
        toast.style.transform = centerX ? 'translate(calc(-50% - 100%), ' + yVal + ')' : (centerY ? 'translate(-100%, -50%)' : 'translateX(-100%)');
      } else if (slideDirections === 'top to bottom') {
        toast.style.transform = centerY ? 'translate(' + xVal + ', calc(-50% - 100%))' : (centerX ? 'translate(-50%, -100%)' : 'translateY(-100%)');
      } else if (slideDirections === 'bottom to top') {
        toast.style.transform = centerY ? 'translate(' + xVal + ', calc(-50% + 100%))' : (centerX ? 'translate(-50%, 100%)' : 'translateY(100%)');
      }
    }

    hideToast(toast, slideDirections) {
      const position = toast.getAttribute('data-toast-position') || '';
      toast.style.opacity = '0';
      toast.style.transform = this.getExitTransform(position, slideDirections);

      setTimeout(() => {
        const parent = toast.parentElement;
        toast.remove();
        if (parent && parent.classList && parent.classList.contains('custom-toast-wrapper') && parent.childNodes.length === 0) {
          parent.remove();
        }
      }, 300);
    }
  }

  window.toastMessage = new CustomToast();

